module.exports = __webpack_public_path__ + "static/media/nutricia-brand-allergens-lupines.162960ee.svg";